import Alpine from "alpinejs";

Alpine.data("circularProgressBar", () => ({
    progressBars: '',

    init() {
        let self = this;

        window.addEventListener('message', (event) => {
            if (event.data.type === 'add-cProgressBar') {
                self.progressBars = JSON.parse(event.data.progressBars);
            }
        });
    },

    getDashOffset(progress) {
        return 100 - progress;
    },

    getProgressText(progress) {
        if (progress) {
            return progress + '%';
        }

        return '';
    },

    getStyle(color, fontSize) {
        let styles = '';

        if (color !== null && color !== undefined) {
            styles += 'color: ' + color + ';';
        }

        if (fontSize !== null && fontSize !== undefined && fontSize !== '') {
            styles += 'font-size: ' + fontSize + 'px; ';
        }
        return styles;
    }
}));